<template>
    <div>
        <div v-if="!isLoading">

             <div class="greybox">
                <input
                    class=""
                    type="search"
                    placeholder="Find claim by reference"
                    aria-label="Search"
                    v-model="quickSearch">
                <button
                    class="button"
                    type="submit"
                    @click="handleFindClick">
                    Find
                </button>&nbsp;
                <button
                    class="button"
                    type="cancel"
                    @click="handleResetClick">
                    Reset
                </button>
            </div>
            <hr />

            <div class="greybox">
                <span v-if="totalRecords == 0">
                    <p>You currently have no gadgets that require a repair invoice to be uploaded.</p>
                </span>
                <div v-if="totalRecords != 0 && !viewAllClaims && claimsList.length > 0">

                    <h2>Your most recent claim...</h2>
                    <div
                        class="claim-list-card mt-2 mb-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p><strong>Claim reference</strong></p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p>{{claimsList[0].claimReference}}</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p><strong>Gadgets</strong></p>
                                        </div>
                                        <div class="col-sm-8">
                                            <div v-for="(gadget, index) in claimsList[0].gadgets" :key="index">
                                                <div v-if="gadget.repairOption">
                                                    <p>{{gadget.displayName}} {{gadget.repairOption.displayName}}</p>
                                                    <button
                                                        v-if="gadget.repairOption.requireInvoiceUpload"
                                                        class="button-small mb-2"
                                                        @click="showFredEx(claimsList[0], gadget)">
                                                        Upload repair invoice
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <p class="float-right" :class="[statusTextColour(claimsList[0])]"><strong>{{claimsList[0].status}}</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button
                        class="button"
                        @click="handleViewAllClick()">
                        View all claims
                    </button>

                </div>
                <div v-if="viewAllClaims">
                    <div
                    v-for="(claim, index) in claimsList"
                    :key="'claimList_' + index"
                    class="claim-list-card mb-2">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <div class="row">
                                    <div class="col-4">
                                        <p><strong>Claim reference</strong></p>
                                    </div>
                                    <div class="col-8">
                                        <p>{{claim.claimReference}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4">
                                        <p><strong>Gadgets</strong></p>
                                    </div>
                                    <div class="col-8">
                                        <div v-for="(gadget, index) in claim.gadgets" :key="index">
                                            <div v-if="gadget.repairOption">
                                                <p>{{gadget.displayName}} {{gadget.repairOption.displayName}}</p>
                                                <button
                                                    v-if="gadget.repairOption.requireInvoiceUpload"
                                                    class="button-small mb-2"
                                                    @click="showFredEx(claimsList[0], gadget)">
                                                    Upload repair invoice
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <p class="float-right" :class="[statusTextColour(claimsList[1])]"><strong>{{claimsList[1].status}}</strong></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <b-pagination
                v-if="(totalRecords > perPage) && viewAllClaims"
                align="right"
                size="md"
                :total-rows="totalRecords"
                v-model="currentPage"
                :per-page="perPage"
                @input="handlePagenationInput">
            </b-pagination>
        </div>

        </div>
        <div v-else>
            <span>Loading...</span>
        </div>

        <!-- <upload-invoice-modal ref="fred" :key="'fred'" :selectedClaim="{}" :gadget="{}" @hidden="handleFredModalHidden()"></upload-invoice-modal> -->

        <!-- <repair-options-modal ref="repairOptionsModal1" :key="'repairOptionsModal1'" :totalExcess="null" :selectedClaim="{}" :gadget="{}" @hidden="handleRepairOptionModalHidden()"> </repair-options-modal> -->

        <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>

    </div>
</template>

<script>

import { mapActions } from 'vuex'

// import uploadInvoiceModal from '@/components/UploadInvoiceModal.vue'

import loading from 'vue-loading-overlay'

export default {
  name: 'uploadRepairDocs',
  components: {
    loading,
    // uploadInvoiceModal
  },
  data: () => {
    return {
      currentPage: 0,
      perPage: 5,
      includeAll: false,
      repairOptionFilter: 1,
      quickSearch: '',
      viewAllClaims: false
    }
  },
  beforeMount () {
    this.load({ includeAll: this.includeAll, repairOptionFilter: this.repairOptionFilter })
  },
  computed: {
    leftBorderColour () {
      return 'border-left-green'
    },
    addMarginTop3 () {
      if (this.$vnode.key > 0) { return 'mt-3' }
    },
    isLoading () {
      return this.$store.state.myclaims.loading
    },
    claimsList () {
      if (this.$store.state.myclaims) {
        return this.$store.state.myclaims.claimsList
      }
    },
    selectedClaim: {
      get () {
        return this.$store.state.myclaims.selectedClaim
      },
      set (value) {
        this.$store.commit('myclaims/setSelectedClaim', value)
      }
    },
    selectedClaimGadgets () {
      if (this.selectedClaim) {
        return this.selectedClaim.gadgets
      }
      return null
    },
    pageSize () {
      if (this.$store.state.myclaims.pagenation) {
        return this.$store.state.myclaims.pagenation.pageSize
      }
      return 5
    },
    totalRecords () {
      if (this.$store.state.myclaims.pagenation) {
        return this.$store.state.myclaims.pagenation.totalRecords
      }
      return 0
    },
    isBankDetailsEmpty () {
      let { bankDetails } = this.$store.state.myclaims.selectedClaim
      if (bankDetails) {
        return bankDetails.name == '' || bankDetails.name == null
      }
      return true
    }
  },
  methods: {
    ...mapActions({
      load: 'myclaims/getClaimsList',
      setGadget: 'myclaims/setSelectedGadget'
    }),
    statusTextColour (claim) {
      if (claim.status == 'DECLINED') { return 'text-danger' }

      if (claim.status == 'APPROVED') { return 'text-success' }

      if (claim.status == 'UNDER REVIEW') { return 'text-warning' }
    },
    showFredEx (claim, gadget) {
      this.selectedClaim = claim
      this.setGadget(gadget)
      if (this.isBankDetailsEmpty) {
        this.$router.push({ path: '/myclaims/repairoptions/bankdetails' })
      } else {
        this.$router.push({ path: '/myclaims/repairoptions/uploaddocs' })  
      }
    },
    showFred (gadget) {
      this.$refs.fred.selectedClaim = this.selectedClaim
      this.$refs.fred.gadget = gadget
      this.$refs.fred.show()
    },
    handleFredModalHidden () {
      this.load({ includeAll: this.includeAll, repairOptionFilter: 1 })
    },
    handlePagenationInput (payload) {
      this.load(
        {
          pageNumber: payload,
          pageSize: this.pageSize,
          includeAll: this.includeAll,
          quickSearch: this.quickSearch,
          repairOptionFilter: this.repairOptionFilter
        })
    },
    handleFindClick () {
      this.load(
        {
          pageSize: this.pageSize,
          includeAll: this.includeAll,
          quickSearch: this.quickSearch,
          repairOptionFilter: this.repairOptionFilter
        })
    },
    handleViewAllClick () {
      this.viewAllClaims = true
    },
    handleResetClick () {
      this.quickSearch = ''
      this.load(
        {
          pageSize: this.pageSize,
          includeAll: this.includeAll,
          quickSearch: this.quickSearch,
          repairOptionFilter: this.repairOptionFilter
        })
    }
  }
}
</script>
